import { __awaiter, __decorate } from "tslib";
import { Datasource } from '@genesislcap/foundation-comms';
import { ErrorBoundaryEvent, getErrorBuilder, getNotificationBuilder, showError, } from '@genesislcap/foundation-errors';
import { createLogger } from '@genesislcap/foundation-logger';
import { attr, nullableNumberConverter, observable } from '@microsoft/fast-element';
import { FoundationElement } from '@microsoft/fast-foundation';
import { foundationErrorBoundaryTemplate as template } from './error-boundary.template';
export const foundationErrorBoundaryShadowOptions = {
    mode: 'open',
    delegatesFocus: true,
};
/**
 * @deprecated
 * @tagname %%prefix%%-error-boundary
 */
export class ErrorBoundary extends FoundationElement {
    constructor() {
        super(...arguments);
        this.logger = createLogger('error-boundary');
        /**
         * Number of milliseconds before toast will disappear. Leave empty or set to 0 to keep toast open indefinitely
         * @public
         */
        this.closeTimeout = 0;
    }
    connectedCallback() {
        const _super = Object.create(null, {
            connectedCallback: { get: () => super.connectedCallback }
        });
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            _super.connectedCallback.call(this);
            this.addEventListener(ErrorBoundaryEvent.ERROR_BOUNDARY_EVENT, (e) => {
                e.stopImmediatePropagation();
                showError(e.detail, this.tagName, this.errorBoundary);
            });
            if (this.resourceName) {
                yield this.datasource.init({
                    resourceName: this.resourceName,
                }, true);
                (_a = this.datasource.stream) === null || _a === void 0 ? void 0 : _a.subscribe((result) => {
                    if (!result.ROW) {
                        return;
                    }
                    const details = result === null || result === void 0 ? void 0 : result.ROW[0];
                    if (result.SEQUENCE_ID > 1) {
                        const title = details.HEADER;
                        const message = details === null || details === void 0 ? void 0 : details.BODY;
                        const type = details.NOTIFY_SEVERITY;
                        showError(getErrorBuilder()
                            .withTitle(title)
                            .withErrorDetails(message)
                            .withNotification(getNotificationBuilder()
                            .withType(type)
                            .withAutoClose(!!this.closeTimeout)
                            .withCloseTimeout(this.closeTimeout)
                            .build())
                            .build(), this.tagName, this.errorBoundary);
                    }
                });
            }
        });
    }
}
__decorate([
    observable
], ErrorBoundary.prototype, "errorBoundary", void 0);
__decorate([
    attr({ attribute: 'resource-name' })
], ErrorBoundary.prototype, "resourceName", void 0);
__decorate([
    attr({ attribute: 'close-timeout', converter: nullableNumberConverter })
], ErrorBoundary.prototype, "closeTimeout", void 0);
__decorate([
    Datasource
], ErrorBoundary.prototype, "datasource", void 0);
/**
 * The Foundation Error Boundary
 *
 * @public
 * @remarks
 * HTML Element: \<foundation-error-boundary\>
 */
export const foundationErrorBoundary = ErrorBoundary.compose({
    baseName: 'error-boundary',
    template,
    shadowOptions: foundationErrorBoundaryShadowOptions,
});
